import { MarketCode } from '@prisjakt/web-app-config/dist/markets/types';
import { PrismicArticle } from 'src/types';
import {
  DangerousConfigReceiveAction,
  InfoPagesReceiveAction,
  SessionReceiveAction,
} from '../../../globals/actions/types';

export const FOOTER_ARTICLES_RECEIVE = 'FOOTER_ARTICLES_RECEIVE';

export interface FooterState {
  socialNetworks: SocialNetwork[];
  current: string;
  sites: Site[];
  articles: PrismicArticle[];
  url?: Url;
  open?: () => void;
}

export type Site = {
  url: string;
  code: MarketCode;
};

export interface SocialNetwork {
  name: string;
  link: string;
}

export interface Url {
  campaigns?: string;
}

export type FooterArticlesRecieveAction = {
  type: 'FOOTER_ARTICLES_RECEIVE';
  articles: PrismicArticle[];
};

export type FooterActionTypes =
  | DangerousConfigReceiveAction
  | InfoPagesReceiveAction
  | SessionReceiveAction
  | FooterArticlesRecieveAction;
